import { useContext, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Store } from "./states/store";
import { AdminProtectedRoute } from "./routes";
import { Header, Footer, SideNavBar, NotFound } from "./components";
import { AdminLoginScreen, Dashboard } from "./pages";
import Users from "./pages/users/Users";
import Genres from "./pages/genres/Genres";
import Stories from "./pages/stories/Stories";
import ViewUser from "./pages/users/ViewUser";
import ViewProfile from "./pages/profile/ViewProfile";
import ViewStories from "./pages/stories/ViewStories";
import PrivacyPolicy from "./pages/privacypolicy/PrivacyPolicy";
import TermsAndCondition from "./pages/termsandcondition/TermsAndCondition";
import ViewGenre from "./pages/genres/ViewGenre";
import AddGenre from "./pages/genres/AddGenre";
import Banners from "./pages/banners/Banners";
import AddBanner from "./pages/banners/AddBanner";
import ViewTransaction from "./pages/transaction/ViewTransaction";
import DeleteAccount from "./pages/deleteaccount/DeleteAccount";
import Transaction from "./pages/transaction/Transaction";
import CreateContactUs from "./pages/contactus/CreateContactUs";
import Queries from "./pages/contactus/Queries";
import GetQuery from "./pages/contactus/GetQuery";
import RefundPolicy from "./pages/refundpolicy/RefundPolicy";


function App() {
  const { state } = useContext(Store);
  const { token } = state;

  const pageLocation = useLocation();

  const [isExpanded, setExpandState] = useState(window.innerWidth > 768);
  const sidebarHandler = () => setExpandState((prev) => !prev);

  // console.log({ isExpanded, token });
  return (
    <div className="main-wrapper">
      {isExpanded && token && (
        <div className="sidebar-overlay" onClick={sidebarHandler}></div>
      )}
      {token && (
        <div className="sidebar-wrapper">
          <SideNavBar isExpanded={isExpanded} />
        </div>
      )}
      <div
        className={`body-wrapper ${isExpanded ? "mini-body" : "full-body"} 
        ${token ? "" : "m-0"} d-flex flex-column`}
      >
        {token && <Header sidebarHandler={sidebarHandler} />}
        <Routes location={pageLocation} key={pageLocation.pathname}>
          <Route
            path="/admin/dashboard"
            element={
              <AdminProtectedRoute>
                <Dashboard />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminProtectedRoute>
                <Users />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/genres"
            element={
              <AdminProtectedRoute>
                <Genres />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/genre/add"
            element={
              <AdminProtectedRoute>
                <AddGenre />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/banners"
            element={
              <AdminProtectedRoute>
                <Banners />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/banner/add"
            element={
              <AdminProtectedRoute>
                <AddBanner />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/events"
            element={
              <AdminProtectedRoute>
                <Stories />
              </AdminProtectedRoute>
            }
          />
          <Route path="/" element={<AdminLoginScreen />} />
          <Route
            exact
            path="/admin/view-profile"
            element={
              <AdminProtectedRoute>
                <ViewProfile />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/view/user/:id"
            element={
              <AdminProtectedRoute>
                <ViewUser />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/view/story/:id"
            element={
              <AdminProtectedRoute>
                <ViewStories />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/view/genre/:id"
            element={
              <AdminProtectedRoute>
                <ViewGenre />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/view/transaction/:id"
            element={
              <AdminProtectedRoute>
                <ViewTransaction />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/transactions"
            element={
              <AdminProtectedRoute>
                <Transaction />
              </AdminProtectedRoute>
            }
          />
          <Route exact path="/admin/contact-us" element={<CreateContactUs />} />
          <Route
            exact
            path="/admin/get-queries"
            element={
              <AdminProtectedRoute>
                <Queries />
              </AdminProtectedRoute>
            }
          />
          <Route
            exact
            path="/admin/get-query/:id"
            element={
              <AdminProtectedRoute>
                <GetQuery />
              </AdminProtectedRoute>
            }
          />
          <Route
            path="/admin/privacy-policy"
            element={<PrivacyPolicy />}
          ></Route>
          <Route
            path="/admin/terms-and-condition"
            element={<TermsAndCondition />}
          ></Route>
           <Route
            path="/admin/refund-policy"
            element={<RefundPolicy />}
          ></Route>
          <Route
            path="/admin/delete-account"
            element={<DeleteAccount />}
          ></Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );
}

export default App;
